/**
 * Katip'ten unvan gelmediğinde backend'in atadığı yer tutucu isimler (ve eski sürüm önekleri).
 */
export function isKatipPlaceholderWorkplaceName(name: string | null | undefined): boolean {
  const n = String(name || '').trim();
  if (!n) return false;
  if (n.startsWith('İSİMSİZ') || n.startsWith('ISIMSIZ')) return true;
  if (n.startsWith('İşyeri — Sicil')) return true;
  return false;
}

/** Düzenleme kutularında yer tutucu isimleri ayırt etmek için (işyeri adı input vb.) */
export function katipPlaceholderInputHighlightStyle(
  name: string | null | undefined
): { borderColor?: string; color?: string } | undefined {
  if (!isKatipPlaceholderWorkplaceName(name)) return undefined;
  return { borderColor: '#dc2626', color: '#dc2626' };
}
